


























import {Component, Prop, Vue} from 'vue-property-decorator';
import {IBaseScenario} from "@/lib/types/IBaseScenario";
import {userStore} from "@/store/store";
import {dateTimeDisplay} from "@/lib/util/dateFunctions";

@Component
export default class ScenarioInformationReport extends Vue {

  @Prop() scenario!: IBaseScenario;
  
  formatDate = dateTimeDisplay;

  get user() {
    return userStore.user
  }

}
